<template>
  <div>
    <div class='h-subscriber-inputLit' v-if="data.showName !== ''">
      {{data.showName}}
    </div>
    <div>
      <input :ref='data.name' :class="['e-control', 'e-textbox', 'e-lib', 'e-input',{ 'readonly-background': data.readonly}]" :placeholder='data.placeholder' :readonly='data.readonly' :name='data.name' v-model='params.paramVal'/>
    </div>
  </div>
</template>
<script>
export default {
  name: 'Son_CheckArray',
  props: [
    'data'
  ],
  data() {
    return {
      params: {
        paramVal: ''
      }
    }
  }
};
</script>

<style scoped>

</style>
